export const enum MrbItemType {
  INCIDENT = 'INCIDENT',
  CAPA = 'CAPA',
  FOLLOWUP = 'FOLLOWUP',
}
